module.exports = __webpack_public_path__ + "c6e63e27fe32f2812da2ba0113251235.png";